import React from 'react';
export function InboxIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M13 10V1h-2v9H8l4 6 4-6h-3z"
  }), React.createElement("path", {
    d: "M21 15V4h-6V2h7a1 1 0 011 1v18a1 1 0 01-1 1H2a1 1 0 01-1-1V3a1 1 0 011-1h7v2H3v11h4.5l.007.058C7.79 17.31 9.73 19 12 19c2.27 0 4.211-1.69 4.493-3.942L16.5 15H21z"
  }));
}